import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AnimatedPageLoader } from 'smartsuite-ui';
import ErrorBoundary from './components/ErrorBoundary';

import 'smartsuite-ui/dist/smartsuite-ui.css';
import './less/brands.css';
import './i18n';

const DefaultRoute = React.lazy(() => import('./components/DefaultRoute'));
const WelcomePage = React.lazy(() => import('./components/WelcomePage'));

const rootElement = document.getElementById('root');

render(
    <ErrorBoundary>
        <Suspense fallback={<AnimatedPageLoader />}>
            <Router basename={window.rootUrl}>
                <Switch>
                    <Route path="/apps/welcome" component={WelcomePage} />
                    <Route exact={true} path="/" component={DefaultRoute} />
                </Switch>
            </Router>
        </Suspense>
    </ErrorBoundary>,
    rootElement
);
